import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Heading from "../../components/common/Typography/Heading";
import ReactTyped from "react-typed";
import { fetchServiceCategories } from "../../Redux/Slice/serviceCategoriesSlice";
import { useGraphQL } from "../../context/GraphQLProvider";
import mainBannerVideo from "../../assets/video/main-banner-video.mp4";

const MainBanner = () => {
  const graphqlService = useGraphQL();
  const dispatch = useDispatch();
  const { categories = [], loading } = useSelector((state) => state.serviceCategories);

  useEffect(() => {
    if (categories.length === 0 && !loading) {
      dispatch(fetchServiceCategories(graphqlService));
    }
  }, [dispatch, categories.length, loading, graphqlService]);

  const serviceNames = categories?.length > 0 
    ? categories.map(category => category.name)
    : ["Services..."];

  const rotatingCategories = ["Plumber", "Electrician", "Roofer", "Painter", "Tiler", "Concreter", "Waterproofer", "Landscaper", "Handyman", "Carpenter"];

  return (
    <>
      <div
        className={`w-[100%] h-screen sm:h-[1000px] lg:h-screen relative`}
      >
        {/* Video Background */}
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover"
        >
          <source src={mainBannerVideo} type="video/mp4" />
        </video>
        
        <div className="tp-container-home mx-auto h-full relative z-10">
          <Heading
            variant={"h1"}
            className={
              "text-start text-white w-full pt-[50vh] sm:pt-[50vh] md:pt-[50vh] lg:pt-[50vh] xl:pt-[50vh] 2xl:pt-[500px]"
            }
          >
            {/* SEARCH. Connect. <br /> Complete. */}
            Connect with Local<br />
            <ReactTyped
              strings={rotatingCategories}
              typeSpeed={100}
              backSpeed={100}
              loop
            />
          </Heading>
          {/* <Heading
            variant={"h6"} className={"text-white"}>
            <ReactTyped
              strings={serviceNames}
              typeSpeed={100}
              backSpeed={100}
              loop
            />
          </Heading> */}
        </div>
      </div>
    </>
  );
};

export default MainBanner;
